export type ChannelListFilterKey =
  | 'channelStatusIds'
  | 'assigneeIds'
  | 'tagNames'
  | 'appointmentClinicEmployeeIds'
  | 'appointmentTypeIds'
  | 'appointmentRoomIds'
  | 'unread'
  | 'showArchived';

type ChannelListFilterValue = string[] | boolean;

export interface IChannelListFilter extends Record<ChannelListFilterKey, ChannelListFilterValue> {
  channelStatusIds: string[];
  assigneeIds: string[];
  tagNames: string[];
  appointmentClinicEmployeeIds: string[];
  appointmentTypeIds: string[];
  appointmentRoomIds: string[];
  unread: boolean;
  showArchived: boolean;
}

export const defaultChannelListFilter: IChannelListFilter = {
  channelStatusIds: [],
  assigneeIds: [],
  tagNames: [],
  appointmentClinicEmployeeIds: [],
  appointmentTypeIds: [],
  appointmentRoomIds: [],
  unread: false,
  showArchived: false,
};
